import { useEffect, useCallback, useState } from 'react';

import { Box, Grid, Button, CircularProgress, FormControlLabel, Checkbox } from '@mui/material';
import { SelectField, TextField, DateTimePicker, MultilineField, Dialog } from 'style-guide';

import { STATUS } from 'constants/global-constants';
import { REQUEST_ACTIONS, sendRequest, setOrderData } from 'utils/Communicator';

import { useDispatch, useSelector } from 'react-redux';
import { getOrders } from 'reducers/order-reducers/ordersSlicer';
import { filterServiceProviderImporter } from 'Utils';

import { snackbarToggle } from 'reducers/snackbarSlicer';
import { addOrderFilter, addSearchFilter, addStatusChatMessage, getStatusChatMessage } from 'Utils';
import { onTruckingCompanyNameOptionsChange, onTruckingCompaniesChange } from 'reducers/TruckingCompanySlicer';
import {
    onUserUSDataChange,
    onUserNLDataChange,
    onUserILDataChange,
} from 'reducers/order-reducers/predefinedDataSlicer';
const ImporterDialog = ({ loginUser, order, openDialog, setOpenDialog, pageName, onHandleCloseDialog1 }) => {
    const dispatch = useDispatch();
    const [ilUsers, setIlUsers] = useState();
    const [nlUsers, setNlUsers] = useState();
    const [usUsers, setUSUsers] = useState();
    const [approveFlag, setApproveFlag] = useState(order.airStatus?.importerExit ? order.airStatus?.importerExit : false);
    const [selfDelivery, setSelfDelivery] = useState(order.selfDelivery ? order.selfDelivery : false);
    const [ignoreFinalDoc, setIgnoreFinalDoc] = useState(order.ignoreFinalDoc ? order.ignoreFinalDoc : false);
    const [customsDate, setCustomsDate] = useState(order.airStatus?.importerDate ? (order.airStatus?.importerDate === "null" ? null : order.airStatus?.importerDate) : null);
    const [deliveryDate, setDeliveryDate] = useState(order.deliveryDate ? (order.deliveryDate === "null" ? null : order.deliveryDate) : null);
    const [truckingCompany, setTruckingCompany] = useState(order.importerTruck);
    const onHandleCheckboxChange = (event, action) => dispatch(action(event.target.checked));
    const onHandleChange = (event, action) => dispatch(action(event.target.value));
    const { truckingCompanyNameOptions } = useSelector(state => state.truckingCompanies);
    const { userILData, userNLData, userUSData } = useSelector(state => state.predefinedData);
    const {
        userLocalNumber,
        userAbroadNumber,
        urgentShipment,
        consigneeId,
        customerId,
        fileUploadStatus,
        shipperId,
        countryOfOriginId, originState, fileNumber,
        shippingModeId,
        subModeId,
        userLocalId, userTracer, userCustoms,
        userAbroadId,
        dueDate,
        lastUpdateDate,
        ilReminderDate,
        reminderDate,
        selectedLocationIndex,
        search,
        startReminderDate,
        endReminderDate,
        startIlReminderDate,
        endIlReminderDate,
        stageSearch,
        stageStateSearch,
        reminderDateAdv, ilReminderDateAdv, etaDate, etdDate, sortFilter } = useSelector(state => state.orderTableFilter);
    const { page, size } = useSelector(state => state.orders);

    const failedCallback = useCallback(message => dispatch(snackbarToggle({ type: 'error', message })), [dispatch]);

    const failedCallback1 = useCallback(message => dispatch(snackbarToggle({ type: 'error', message:"Save failed, please ensure that delivery stage is in progress." })), [dispatch]);

    const onHandleCloseDialog = () => {
        setOpenDialog(false);
    };
    const { truckingCompanies } = useSelector(state => state.truckingCompanies);

    useEffect(() => {
        const truckingCompanyNameOptions = truckingCompanies.map(company => {
            return { id: company.id, name: company.companyName, serviceProviderLocationId: company.serviceProviderLocationId, };
        });

        dispatch(onTruckingCompanyNameOptionsChange(truckingCompanyNameOptions));
    }, [truckingCompanies, dispatch]);
    useEffect(() => {
        if (!truckingCompanies || truckingCompanies.length <= 0) {
            sendRequest('/api/serviceProvider/3?activeFlag=true', REQUEST_ACTIONS.GET, '', {
                successCallback: response => {
                    dispatch(onTruckingCompaniesChange(response));
                    dispatch(onTruckingCompanyNameOptionsChange({ id: response.id, name: response.companyName, serviceProviderLocationId: response.serviceProviderLocationId, }));
                },
                failedCallback,
            });
        }
    }, [failedCallback, dispatch, truckingCompanies]);

    useEffect(() => {
        // predefined user abroad data get
        if (!userNLData) {
            sendRequest('/api/users/NL', REQUEST_ACTIONS.GET, '', {
                loginUser: loginUser,
                successCallback: response => {
                    onUserNLDataChange(response);
                    setNlUsers(response);
                    setNlUsersLoaded(true)
                },
                failedCallback,
            });
        } else {
            setNlUsers(userNLData);
        }
    }, [userNLData]);

    useEffect(() => {
        // predefined user abroad data get
        if (!userUSData) {
            sendRequest('/api/users/US', REQUEST_ACTIONS.GET, '', {
                loginUser: loginUser,
                successCallback: response => {
                    onUserUSDataChange(response);
                    setUSUsers(response);
                    setUSUsersLoaded(true)
                },
                failedCallback,
            });
        } else {
            setUSUsers(userUSData);
        }
    }, [userUSData]);

    useEffect(() => {
        // predefined user local data get
        if (!userILData) {
            sendRequest('/api/users/IL', REQUEST_ACTIONS.GET, '', {
                loginUser: loginUser,
                successCallback: response => {
                    onUserILDataChange(response);
                    setIlUsers(response);
                    setIlUsersLoaded(true)
                },
                failedCallback,
            });
        } else {
            setIlUsers(userILData);
        }
    }, [userILData]);


    const saveCustomsData = () => {
        if (order.shippingModeId == 1) {
            sendRequest(`/api/fa/setImporterExitAir/${order.id}/${loginUser.id}/${selfDelivery}/${ignoreFinalDoc}/${approveFlag}/${truckingCompany}/${customsDate}/${deliveryDate}`, REQUEST_ACTIONS.GET, null, {
                successCallback: data => {
                    //dispatch(snackbarToggle({ type: 'success', message: 'chat updated successfully' }));
                    sendRequest(`/api/order/count?${addOrderFilter(loginUser, pageName, selectedLocationIndex)}${addSearchFilter(customerId, urgentShipment, userLocalNumber, userAbroadNumber, consigneeId, shipperId, countryOfOriginId, originState, shippingModeId, subModeId, userLocalId, userTracer, userCustoms, userAbroadId, dueDate, search, lastUpdateDate, reminderDate, ilReminderDate, startReminderDate, endReminderDate, startIlReminderDate, endIlReminderDate, stageSearch, stageStateSearch, reminderDateAdv, ilReminderDateAdv, pageName, sortFilter, fileNumber, etaDate, etdDate, fileUploadStatus)}page=${page}&size=${size}`, REQUEST_ACTIONS.GET, '', {
                        successCallback: response => { },
                        failedCallback,
                    });
                    sendRequest(`/api/order/advOrders?${addOrderFilter(loginUser, pageName, selectedLocationIndex)}${addSearchFilter(customerId, urgentShipment, userLocalNumber, userAbroadNumber, consigneeId, shipperId, countryOfOriginId, originState, shippingModeId, subModeId, userLocalId, userTracer, userCustoms, userAbroadId, dueDate, search, lastUpdateDate, reminderDate, ilReminderDate, startReminderDate, endReminderDate, startIlReminderDate, endIlReminderDate, stageSearch, stageStateSearch, reminderDateAdv, ilReminderDateAdv, pageName, sortFilter, fileNumber, etaDate, etdDate, fileUploadStatus)}page=${page}&size=${size}`, REQUEST_ACTIONS.GET, '', {
                        successCallback: response => {
                            setOrderData(dispatch, getOrders, response, loginUser, failedCallback);
                            setOpenDialog(false);
                        },
                        failedCallback,
                    });
                },
                failedCallback1,
            });
        } else {
            sendRequest(`/api/fa/setImporterExitSea/${order.id}/${loginUser.id}/${selfDelivery}/${ignoreFinalDoc}/${approveFlag}/${truckingCompany}/${customsDate}/${deliveryDate}`, REQUEST_ACTIONS.GET, null, {
                successCallback: data => {
                    //dispatch(snackbarToggle({ type: 'success', message: 'chat updated successfully' }));
                    sendRequest(`/api/order/count?${addOrderFilter(loginUser, pageName, selectedLocationIndex)}${addSearchFilter(customerId, urgentShipment, userLocalNumber, userAbroadNumber, consigneeId, shipperId, countryOfOriginId, originState, shippingModeId, subModeId, userLocalId, userTracer, userCustoms, userAbroadId, dueDate, search, lastUpdateDate, reminderDate, ilReminderDate, startReminderDate, endReminderDate, startIlReminderDate, endIlReminderDate, stageSearch, stageStateSearch, reminderDateAdv, ilReminderDateAdv, pageName, sortFilter, fileNumber, etaDate, etdDate, fileUploadStatus)}page=${page}&size=${size}`, REQUEST_ACTIONS.GET, '', {
                        successCallback: response => {
                            sendRequest(`/api/order/advOrders?${addOrderFilter(loginUser, pageName, selectedLocationIndex)}${addSearchFilter(customerId, urgentShipment, userLocalNumber, userAbroadNumber, consigneeId, shipperId, countryOfOriginId, originState, shippingModeId, subModeId, userLocalId, userTracer, userCustoms, userAbroadId, dueDate, search, lastUpdateDate, reminderDate, ilReminderDate, startReminderDate, endReminderDate, startIlReminderDate, endIlReminderDate, stageSearch, stageStateSearch, reminderDateAdv, ilReminderDateAdv, pageName, sortFilter, fileNumber, etaDate, etdDate, fileUploadStatus)}page=${page}&size=${size}`, REQUEST_ACTIONS.GET, '', {
                                successCallback: response => {
                                    setOrderData(dispatch, getOrders, response, loginUser, failedCallback);
                                    setOpenDialog(false);
                                },
                                failedCallback,
                            });
                        },
                        failedCallback,
                    });
                },
                failedCallback1,
            });
        }
    }

    const getTruckingOptions = () => {
        var options = filterServiceProviderImporter(2, truckingCompanyNameOptions)
        return options
    }
    const onUpdateChat = (id, chatString, fromStage) => {
        var data = {
            value: chatString
        }
        sendRequest(`/api/order/updateChat/${id}?fromStage=${fromStage}&loginUserId=` + loginUser?.id + `&actionOn=DepartureDialog`, REQUEST_ACTIONS.PUT, data, {
            successCallback: data => {
                //dispatch(snackbarToggle({ type: 'success', message: 'chat updated successfully' }));
                sendRequest(`/api/order/advOrders?${addOrderFilter(loginUser, pageName, selectedLocationIndex)}${addSearchFilter(customerId, urgentShipment, userLocalNumber, userAbroadNumber, consigneeId, shipperId, countryOfOriginId, originState, shippingModeId, subModeId, userLocalId, userTracer, userCustoms, userAbroadId, dueDate, search, lastUpdateDate, reminderDate, ilReminderDate, startReminderDate, endReminderDate, startIlReminderDate, endIlReminderDate, stageSearch, stageStateSearch, reminderDateAdv, ilReminderDateAdv, pageName, sortFilter, fileNumber, etaDate, etdDate, fileUploadStatus)}page=${page}&size=${size}`, REQUEST_ACTIONS.GET, '', {
                    successCallback: response => {
                        setOrderData(dispatch, getOrders, response, loginUser, failedCallback);
                        onHandleCloseDialog();
                    },
                    failedCallback,
                });
            },
            failedCallback,
        });
    };
    return (
        <Dialog maxWidth='md' open={openDialog} onHandleCancel={onHandleCloseDialog} title={'Delivery - ' + order?.jobNumber}>

            {order.shippingModeId != 1 && <Grid item container flexWrap="nowrap">
                {
                    <Grid container spacing={2} style={{marginBottom: "20px"}}>
                        {order.taskyam?.data?.ContainerInvalidForTooLong &&
                            <Grid item container>Container has not been returned for more than 7 days.</Grid>}
                    </Grid>
                }
            </Grid>}
            <Grid item container flexWrap="nowrap">
                {<Grid container spacing={2} flexDirection="column" flexWrap="nowrap">
                    {order.orderStatus[7].status === "SUCCESS" && <view style={{ marginLeft: 15 }}>
                        <FormControlLabel
                            control={
                                <Checkbox disabled={order.orderStatus[7].status !== "SUCCESS" || selfDelivery} checked={approveFlag} onChange={event => {
                                    setApproveFlag(!approveFlag);
                                    setCustomsDate(new Date());
                                    setDeliveryDate(new Date());
                                }} />
                            }
                            label='Delivered'
                        />
                    </view>}
                    {<view style={{ marginLeft: 15 }}>
                        <FormControlLabel
                            control={
                                <Checkbox disabled={approveFlag} checked={selfDelivery} onChange={event => {
                                    setSelfDelivery(!selfDelivery);
                                    setCustomsDate(new Date());
                                    setDeliveryDate(new Date());
                                }} />
                            }
                            label='Self Delivery'
                        />
                    </view>}
                    {<view style={{ marginLeft: 15 }}>
                        <FormControlLabel
                            control={
                                <Checkbox checked={ignoreFinalDoc} onChange={event => setIgnoreFinalDoc(!ignoreFinalDoc)} />
                            }
                            label='Final Document'
                        />
                    </view>}
                    {/*<DateTimePicker
                        required
                        label='Importer Delivered Time'
                        value={customsDate}
                        onChange={date => setCustomsDate(date)}
                    />*/}
                    <DateTimePicker
                        required
                        label='Delivery date'
                        value={deliveryDate}
                        onChange={date => setDeliveryDate(date)}
                    />

                    <SelectField
                        lg={12}
                        label='Trucking CO'
                        options={getTruckingOptions()}
                        value={truckingCompany}
                        onChange={event => setTruckingCompany(event.target.value)}
                    />
                    {false && <Button
                        dissabled={!approveFlag}
                        variant='contained'
                        style={{ margin: "15px", maxWidth: "150px" }}
                        onClick={saveCustomsData}>
                        Save
                    </Button>}
                    {<Grid container spacing={2} flexDirection="row" flexWrap="nowrap" style={{ marginTop: "10px" }} justifyContent="flex-end">
                        {loginUser.department != 4 && <Button
                            variant='contained'
                            style={{ margin: "15px", maxWidth: "150px" }}
                            onClick={saveCustomsData}>
                            Save
                        </Button>}
                        <Button
                            variant='contained'
                            style={{ margin: "15px", maxWidth: "150px" }}
                            onClick={onHandleCloseDialog1}>
                            Cancel
                        </Button>
                    </Grid>}
                </Grid>}
            </Grid>
        </Dialog>
    );
};

export default ImporterDialog;
